import { saveAs } from "file-saver";
import docSupEquipmentDoc from 'assets/documents/Υπόδειγμα Λίστα Εξοπλισμού.xlsx';
import docSupCertEquipmentDoc from 'assets/documents/Υπεύθυνη Δήλωση Συμμόρφωσης.docx';
import { InfoMessage } from 'components';

export const content = () =>
  [
   {
      label:
      (
        <span>
          <span>
            <b>Μεταφόρτωση Αρχείου Εξοπλισμού</b><span>&nbsp;</span><text style={{fontWeight:"normal", fontSize:"11px"}}>(Κατεβάστε το υπόδειγμα <a style={{textDecoration: "underline"}} onClick={()=>saveAs(docSupEquipmentDoc, "Λίστα Εξοπλισμού")}>εδώ</a>)</text>
          </span>
        </span>
      ),
      fileCode: 'supEquipmentDoc',
      id: 'supEquipmentDoc',
      fileLimit: 10,
      required: false,
      fileAccepts: ['.xlsx'],
      descriptionUpload: 'Κάντε κλικ για ανέβασμα ή σύρετε και αποθέστε αρχείo',
    },
    {
      label:
        <div style={{display:'flex', marginRight:'5px'}}>
        <b>Έγγραφα Πιστοποίησης Εξοπλισμού</b><span>&nbsp;</span><text style={{fontWeight:"normal", fontSize:"11px"}}>(Κατεβάστε το υπόδειγμα <a style={{textDecoration: "underline"}} onClick={()=>saveAs(docSupCertEquipmentDoc, "Υπεύθυνη Δήλωση Συμμόρφωσης")}>εδώ</a>)</text>        <InfoMessage
        infoMessage="Σε περίπτωση που ο προμηθευτής δεν δύναται να αναρτήσει τα επίσημα έγγραφα Πιστοποίησης Εξοπλισμού ή ο εξοπλισμός που έχει αναρτήσει αποτελεί προϊόν σύνθεσης όπου η τελική διαμόρφωση και συναρμολόγηση γίνεται από τον προμηθευτή και όχι από τον κατασκευαστή τότε θα πρέπει να αναρτά σε αυτό το πεδίο, Υπεύθυνη Δήλωση Πιστοποίησης Εξοπλισμού, Υπόδειγμα της οπόιας μπορεί να βρεί στο link δίπλα στον τίτλο του πεδίου."
        overlayClassName={'multiline-info-message'}
        />
      </div>,
      fileCode: 'supCertEquipmentDoc',
      id: 'supCertEquipmentDoc',
      fileLimit: 10,
      multiple: true,
      required: false,
      fileAccepts: ['.pdf', '.jpeg', '.jpg', '.png'],
      descriptionUpload: 'Κάντε κλικ για ανέβασμα ή σύρετε και αποθέστε αρχείo',
    },
    
  ].filter(item => item);;
